import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionCreator, {
  actionForFullUrls,
} from "../../../redux/action/actionCreator";

// core-components
// import CreationForm from "../Form/Wizard";
import Toast from "../../../components/MessageToast";
import GalleryForm from "../../components/forms/galleryForm";
import {
  UPLOAD_IMAGE,
  UPDATE_IMAGE,
} from "../../../redux/gallery/types";
import { UPLOAD_VIDEO, UPDATE_VIDEO } from "../../../redux/gallery/videos/types";
// import { FETCH_CLIENTS } from "../../../redux/clients/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchImageData, fetchVideoData } from "../../../redux/gallery/actions";

const formatCreateData = (data) =>
  data.map((elt) => ({
    id: elt.categoryId,
    name: elt.categoryName,
  }));

export default (props) => {
  const { imageId } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const operationStore = useSelector((store) =>
    imageId ? store.updateImageGlobalStore : store.uploadImageGlobalStore
  );

  const imageData = useSelector((state) => state.imageGlobalStore);

  const openToast = ({ message, type, onClose }) =>
    Toast({ message, type, duration: 3000, onClose });

  const [formState, setFormState] = useState({
    openToast: false,
    currentStep: 1,
    articleId: null,
    articleInfo: {},
  });

  useEffect(() => {
    if (imageId) {
      dispatch(fetchImageData(imageId));
    }
  }, []);

  const handleFormSubmit = async (formData) => {
    const { title, category, imageUrl, thumbnail } = formData;
    const imageInfo = {
      title,
      category,
      imageUrl,
      thumbnail: thumbnail === "" ? imageUrl : thumbnail,
    };
    console.log(imageInfo, "==== these are the pages weare ");
    await toast.promise(
      dispatch(
        actionCreator({
          method: imageId ? "PATCH" : "POST",
          path: imageId ? `/api/gallery/photos/${imageId}` : `/api/gallery/photos`,
          actionType: imageId ? UPDATE_IMAGE : UPLOAD_IMAGE,
          data: imageInfo,
        })
      ),
      {
        pending: `${!imageId ? "Uploading" : "Updating"} Image`,
        success: operationStore.message,
        error: `Unable to ${!imageId ? "Create" : "Update"} Image`,
      }
    );
    navigate("/gallery");
  };

  const crumps = [
    {
      title: "Gallery",
      path: "/gallery",
    },
  ];

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {imageId && imageData.loading ? (
        <Loading />
      ) : (
        <div>
          <GalleryForm
            isCreate={imageId ? false : true}
            onSubmit={handleFormSubmit}
            openToast={openToast}
            baseGalleryData={imageData?.data || {}}
            isLoading={operationStore?.loading}
          />
        </div>
      )}
    </div>
  );
};
